import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FwButtonModule, FwIconButtonModule } from '@flywheel-io/vision';

import { ViewerFrameDialog } from './frame/viewer-frame-dialog.component';
import { ViewerFrameComponent } from './frame/viewer-frame.component';
import { HTMLViewerDialog } from './html-viewer/html-viewer-dialog.component';
import { LegacyOhifViewerDialog } from './legacy-ohif-viewer/legacy-ohif-viewer-dialog.component';
import { MarkdownService } from './markdown.service';
import { MaterialModule } from '../material.module';
import { OhifViewerDialog } from './ohifviewer/ohifviewer-dialog.component';
import { PDFViewerDialog } from './pdf-viewer/pdf-viewer-dialog.component';
import { PipesModule } from '../shared/pipes.module';
import { TextViewerDialog } from './text-viewer/text-viewer-dialog.component';
import { VideoViewerDialog } from './video-viewer/video-viewer-dialog.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatDialogModule,
    PipesModule,
    FwButtonModule,
    FwIconButtonModule,
    SharedModule,
  ],
  declarations: [
    HTMLViewerDialog,
    LegacyOhifViewerDialog,
    OhifViewerDialog,
    PDFViewerDialog,
    TextViewerDialog,
    VideoViewerDialog,
    ViewerFrameComponent,
    ViewerFrameDialog,
  ],
  providers: [
    MarkdownService,
  ],
})
export class ViewerModule { }
